import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLRenewalsReportAdditionalFilter.metadata.json5';
import './MLRenewalsReportAdditionalFilter.messages';

const MLRenewalsReportAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData
    } = props;
    const { refreshData } = useDataRefresh();

    const onValueChange = (value) => {
        _.set(filterData, 'renewalPercentageChange_Ext', value);
        updateFilterData(filterData);
        refreshData();
    };

    const overrideProps = {
        percentageChangeDropdown: {
            onValueChange,
            value: _.get(filterData, 'renewalPercentageChange_Ext')
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
        />
    );
};

MLRenewalsReportAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired
};

export default MLRenewalsReportAdditionalFilter;
